import PropTypes from "prop-types";
import { Box, Typography, TextField, Autocomplete, Button, CircularProgress } from "@mui/material";
import { FilterAltOutlined, RestartAlt } from "@mui/icons-material";
import { yesterdayInBogota, validateVipUsageFilters } from "modules/came/model/vipUsageDates";
export default function UsoVipFilters({ filters, groups, onChange, onApply, onReset, loading }) {
  const invalid = validateVipUsageFilters(filters);
  const latestDate = yesterdayInBogota();
  const fieldSx = {
    "& .MuiOutlinedInput-root": { minHeight: 46, borderRadius: 2, bgcolor: "background.paper" },
    "& .MuiFormHelperText-root": { mx: 0 },
  };
  return (
    <Box component="section" aria-label="Filtros de Uso de VIP">
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2.5 }}>
        <FilterAltOutlined color="info" />
        <Typography variant="subtitle2" fontWeight={600}>
          Filtros de consulta
        </Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gap: 2.5,
          gridTemplateColumns: {
            xs: "minmax(0,1fr)",
            sm: "repeat(2,minmax(0,1fr))",
            lg: "repeat(4,minmax(0,1fr))",
          },
        }}
      >
        <TextField
          type="date"
          label="Fecha de inicio"
          value={filters.startDate}
          onChange={(e) => onChange({ startDate: e.target.value })}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
          inputProps={{
            max: filters.endDate && filters.endDate < latestDate ? filters.endDate : latestDate,
          }}
          helperText="Desde las 00:00"
          sx={fieldSx}
        />
        <TextField
          type="date"
          label="Fecha de fin"
          value={filters.endDate}
          onChange={(e) => onChange({ endDate: e.target.value })}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: filters.startDate || undefined, max: latestDate }}
          error={!!invalid}
          helperText={invalid || "Hasta las 23:59 · Máximo ayer"}
          sx={fieldSx}
        />
        <TextField
          label="Placa"
          placeholder="Buscar placa completa o parcial"
          value={filters.plate}
          onChange={(e) => onChange({ plate: e.target.value.toUpperCase() })}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
          helperText="Coincidencia completa o parcial"
          sx={fieldSx}
        />
        <Autocomplete
          options={groups}
          value={groups.find((g) => String(g.idgroup) === String(filters.groupId)) || null}
          getOptionLabel={(option) => String(option.name || `Grupo ${option.idgroup}`)}
          isOptionEqualToValue={(a, b) => String(a.idgroup) === String(b.idgroup)}
          onChange={(_, group) => onChange({ groupId: group?.idgroup ?? "" })}
          noOptionsText="No hay grupos disponibles"
          openText="Mostrar grupos"
          clearText="Todos los grupos"
          ListboxProps={{ style: { maxHeight: 280 } }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Grupo u oficina"
              placeholder="Todos los grupos"
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              helperText="Filtrar por grupo asignado"
            />
          )}
          sx={fieldSx}
        />
      </Box>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: { xs: "100%", sm: "auto" },
            "& .MuiButton-root": {
              minHeight: 44,
              px: 2,
              borderRadius: 2,
              textTransform: "none",
              flex: { xs: 1, sm: "initial" },
            },
          }}
        >
          <Button
            variant="contained"
            disabled={loading || !!invalid}
            onClick={onApply}
            startIcon={
              loading ? <CircularProgress size={16} color="inherit" /> : <FilterAltOutlined />
            }
            sx={{
              bgcolor: "info.main",
              color: "#fff",
              "&:hover": { bgcolor: "info.dark", color: "#fff" },
            }}
          >
            {loading ? "Consultando…" : "Aplicar"}
          </Button>
          <Button
            variant="outlined"
            disabled={loading}
            onClick={onReset}
            startIcon={<RestartAlt />}
            sx={{ color: "text.secondary", borderColor: "divider" }}
          >
            Restablecer
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
UsoVipFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
